module.exports = function getResource(label) {
    let resources = {
        gotIt: 'OK',
        undo: 'Annuler'
    };

    return resources[label];
};
